import useInView from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const TERROIR_IMG = 'https://customer-assets.emergentagent.com/job_04606eda-c805-4e3a-af14-63242db4ed24/artifacts/7wpvdgwx_IMG_2743.JPG';

const Terroir = () => {
  const [ref, inView] = useInView(0.08);
  const { t } = useLanguage();

  return (
    <section id="terroir" data-testid="terroir-section" className="bg-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">

          {/* Image — left */}
          <div className={`reveal lg:col-span-7 ${inView ? 'visible' : ''}`}>
            <div className="relative overflow-hidden" style={{ aspectRatio: '3/2' }}>
              <img
                src={TERROIR_IMG}
                alt="Vineyard terroir — Zdravets, Northern Black Sea"
                className="w-full h-full object-cover parallax-img"
                loading="lazy"
              />
            </div>
          </div>

          {/* Text — right */}
          <div className="lg:col-span-5">
            <div className={`reveal reveal-delay-1 ${inView ? 'visible' : ''}`}>
              <span className="section-label">{t.terroir.label}</span>
              <div className="line-gold mt-4 mb-8" />
            </div>

            <h2
              className={`reveal reveal-delay-2 font-heading font-light text-obsidian leading-tight mb-7 ${inView ? 'visible' : ''}`}
              style={{ fontSize: 'clamp(1.9rem, 3.5vw, 3rem)' }}
            >
              {t.terroir.heading[0]}<br />{t.terroir.heading[1]}
            </h2>

            <div className={`reveal reveal-delay-3 space-y-4 font-body text-winery-text text-base leading-relaxed ${inView ? 'visible' : ''}`}>
              <p>{t.terroir.para1}</p>
              <p>{t.terroir.para2}</p>
              <p>{t.terroir.para3}</p>
            </div>

            <div className={`reveal reveal-delay-4 mt-10 pt-8 border-t border-winery-border grid grid-cols-2 gap-6 ${inView ? 'visible' : ''}`}>
              {t.terroir.stats.map((item) => (
                <div key={item.label}>
                  <p className="font-body text-xs tracking-widest uppercase text-winery-gold mb-1">{item.label}</p>
                  <p className="font-heading text-lg font-light text-obsidian">{item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terroir;
